import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// MindPlus components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

// Image
import bgImage from "assets/images/illustrations/illustration-reset.jpg";

import { useAuth } from "utils/AuthProvider";
import { API_URL } from "context/dataContext";

const axios = require("axios").default;

function SignIn() {
  const { cookies, login } = useAuth();

  const navigate = useNavigate();

  const [rememberMe, setRememberMe] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSB, setErrorSB] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Error"
      content={errorMessage}
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Success"
      content={successMessage}
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    //setToken(token);
    var token = cookies.token;
    console.log(token);
    if (token) {
      login(token);
      navigate("/dashboard");
    }
  }, []);

  function SignIn() {
    if (email !== "" && password !== "") {
      // login("JKSKKJBD5278358HVSHGVA", "prashant.goraparthi@gmail.com", "Master");
      // setSuccessMessage("Login Successful");
      // openSuccessSB();
      // setTimeout(() => {
      //   navigate("/dashboard");
      // }, 600);
      axios
        .post(`${API_URL}/api/users/login`, {
          user_email: email,
          user_password: password,
        })
        .then(function (response) {
          console.log(response.data);
          if (response.data.status === "login successful") {
            if (
              response.data.user_type === "Admin" ||
              response.data.user_type === "Master" ||
              response.data.user_type === "Sub-Admin" ||
              response.data.user_type === "Marketing" ||
              response.data.user_type === "Support"
            ) {
              login(response.data.token, response.data.user_email, response.data.user_type);
              console.log(response.data.token, response.data.user_email, response.data.user_type);

              setSuccessMessage("Login Successful");
              setErrorMessage("");
              openSuccessSB();
              setTimeout(() => {
                navigate("/dashboard");
              }, 600);

              //window.location.href = ''
            } else {
              setErrorMessage(
                "You are not allowed to access this portal. Please contact the administrator"
              );
              openErrorSB();
              //alert('You are not allowed to access this portal. Please contact the administrator')
            }
          } else {
            setErrorMessage("Please check your credentials and try again.");
            openErrorSB();
            //alert('Please check your credentials and try again.')
          }

          //window.location.href = '/dashboard'
        })
        .catch(function (error) {
          setErrorMessage("Something went wrong");
          openErrorSB();
          console.log(error);
        });
    } else {
      //window.location.href = '/dashboard'
      setErrorMessage("Please enter the details to continue.");
      openErrorSB();
    }
    //window.location.href = '/dashboard'
  }

  return (
    <IllustrationLayout
      title="Sign In"
      description="Enter your email and password to sign in"
      illustration={bgImage}
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            type="email"
            label="Email"
            variant="standard"
            fullWidth
            placeholder="john@example.com"
            InputLabelProps={{ shrink: true }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Password"
            variant="standard"
            fullWidth
            placeholder="************"
            InputLabelProps={{ shrink: true }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(event) => {
              //console.log(event)
              if (event.key === "Enter") {
                SignIn();
              }
            }}
          />
        </MDBox>
        <MDBox display="flex" alignItems="center" ml={-1}>
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
          >
            &nbsp;&nbsp;Remember me
          </MDTypography>
        </MDBox>

        <MDBox display="flex" alignItems="center" ml={-1}>
          <MDTypography variant="caption" fontWeight="regular" color="error">
            {errorMessage}
          </MDTypography>
        </MDBox>

        <MDBox mt={4} mb={1}>
          <MDButton onClick={SignIn} variant="gradient" color="primary" size="large" fullWidth>
            sign in
          </MDButton>
        </MDBox>
        {/* <MDBox mt={3} textAlign="center">
          <MDTypography variant="button" color="text">
            Don&apos;t have an account?{" "}
            <MDTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="secondary"
              fontWeight="medium"
              textGradient
            >
              Sign up
            </MDTypography>
          </MDTypography>
        </MDBox> */}
      </MDBox>
    </IllustrationLayout>
  );
}

export default SignIn;
